import React, { useState, useRef } from "react";

const BASE_URL = "https://mis.empowerplus.in";

const MODULES = [
    {
        label: "Centers",
        endpoint: "centers",
        keyField: "centerId",
        idKey: "centerId",
        keyExample: "EP/TC-A00001",
        excelCols: [
            { col: "A", name: "centerId", note: "KEY — must match existing record", isKey: true },
            { col: "B", name: "creationDate", note: "yyyy-MM-dd" },
            { col: "C", name: "sidhCenterId", note: "" },
            { col: "D", name: "centerType", note: "" },
            { col: "E", name: "trainingCentreName", note: "" },
            { col: "F", name: "address", note: "" },
            { col: "G", name: "nearbyLandmark", note: "" },
            { col: "H", name: "pincode", note: "" },
            { col: "I", name: "state", note: "" },
            { col: "J", name: "district", note: "" },
            { col: "K", name: "geoLocation", note: "" },
            { col: "L", name: "addressProofDocument", note: "" },
            { col: "M", name: "spocName", note: "" },
            { col: "N", name: "spocEmail", note: "" },
            { col: "O", name: "spocMobile", note: "" },
            { col: "P", name: "areaSqft", note: "number" },
            { col: "Q", name: "maleWashroom", note: "number" },
            { col: "R", name: "femaleWashroom", note: "number" },
            { col: "S", name: "unisexWashroom", note: "number" },
            { col: "T", name: "totalLabs", note: "number" },
            { col: "U", name: "totalClassroom", note: "number" },
            { col: "V", name: "itLab", note: "Yes / No" },
            { col: "W", name: "receptionArea", note: "Yes / No" },
        ],
    },
    {
        label: "Assessors",
        endpoint: "assessors",
        keyField: "assessorId",
        idKey: "assessorId",
        keyExample: "EP/AS-A00001",
        excelCols: [
            { col: "A", name: "assessorId", note: "KEY — must match existing record", isKey: true },
            { col: "B", name: "creationDate", note: "yyyy-MM-dd" },
            { col: "C", name: "assessorName", note: "" },
            { col: "D", name: "assessorMobileNumber", note: "" },
            { col: "E", name: "assessorPersonalEmail", note: "" },
            { col: "F", name: "assessorOfficeEmail", note: "" },
            { col: "G", name: "sidhArId", note: "" },
            { col: "H", name: "toaCertified", note: "" },
            { col: "I", name: "certificationName", note: "" },
            { col: "J", name: "certificationId", note: "" },
            { col: "K", name: "certificationValidity", note: "" },
        ],
    },
    {
        label: "Courses",
        endpoint: "courses",
        keyField: "courseId",
        idKey: "courseId",
        keyExample: "EP/2025-26/CSR/Course/001",
        excelCols: [
            { col: "A", name: "courseId",                 note: "KEY — must match existing record", isKey: true },
            { col: "B", name: "courseType",               note: "" },
            { col: "C", name: "sector",                   note: "" },
            { col: "D", name: "jobRoleMappingType",       note: "" },
            { col: "E", name: "qpCode",                   note: "" },
            { col: "F", name: "courseName",               note: "" },
            { col: "G", name: "nsqfLevel",                note: "number" },
            { col: "H", name: "minimumAge",               note: "number" },
            { col: "I", name: "minimumEducationRequired", note: "" },
            { col: "J", name: "courseDurationDays",       note: "number" },
            { col: "K", name: "courseDurationHours",      note: "number" },
            { col: "L", name: "hoursPerDay",              note: "number" },
            { col: "M", name: "courseValidity",           note: "yyyy-MM-dd" },
        ],
    },
    {
        label: "Batches",
        endpoint: "batches",
        keyField: "epBatchId",
        idKey: "epBatchId",
        keyExample: "EP/2025-26/CSR/Batch/001",
        excelCols: [
            { col: "A", name: "epBatchId",               note: "KEY — must match existing record", isKey: true },
            { col: "B", name: "fy",                       note: "" },
            { col: "C", name: "batchCreationDate",        note: "yyyy-MM-dd" },
            { col: "D", name: "scheme",                   note: "" },
            { col: "E", name: "projectImplementationType",note: "" },
            { col: "F", name: "sectorName",               note: "" },
            { col: "G", name: "jobRoleName",              note: "" },
            { col: "H", name: "associatedQpCode",         note: "" },
            { col: "I", name: "nsqfLevel",                note: "number" },
            { col: "J", name: "trainingHoursPerDay",      note: "number" },
            { col: "K", name: "batchStartTime",           note: "" },
            { col: "L", name: "batchEndTime",             note: "" },
            { col: "M", name: "batchName",                note: "" },
            { col: "N", name: "batchStartDate",           note: "yyyy-MM-dd" },
            { col: "O", name: "batchEndDate",             note: "yyyy-MM-dd" },
            { col: "P", name: "batchType",                note: "" },
            { col: "Q", name: "batchSize",                note: "number" },
            { col: "R", name: "assessmentMode",           note: "" },
            { col: "S", name: "proposedAssessmentDate",   note: "yyyy-MM-dd" },
            { col: "T", name: "trainingFee",              note: "number" },
            { col: "U", name: "feesPaidBy",               note: "" },
            { col: "V", name: "feesPaidByName",           note: "" },
            { col: "W", name: "sidhBatchId",              note: "" },
        ],
    },
    {
        label: "Trainers",
        endpoint: "trainers",
        keyField: "trainerId",
        idKey: "trainerId",
        keyExample: "EP/TR-00001",
        excelCols: [
            { col: "A", name: "trainerId",            note: "KEY — must match existing record", isKey: true },
            { col: "B", name: "creationDate",         note: "yyyy-MM-dd" },
            { col: "C", name: "trainerName",          note: "" },
            { col: "D", name: "trainerMobileNumber",  note: "" },
            { col: "E", name: "trainerPersonalEmail", note: "" },
            { col: "F", name: "trainerOfficeEmail",   note: "" },
            { col: "G", name: "sidhTrId",             note: "" },
            { col: "H", name: "toTCertified",         note: "true / false / yes / no / 1 / 0" },
            { col: "I", name: "certificationName",    note: "" },
            { col: "J", name: "certificationId",      note: "" },
            { col: "K", name: "certificationValidity",note: "" },
        ],
    },
    {
        label: "Mobilizations",
        endpoint: "mobilizations",
        keyField: "beneficiaryId",
        idKey: "beneficiaryId",
        keyExample: "EP/BEN-00001",
        excelCols: [
            { col: "A",  name: "beneficiaryId",                    note: "KEY — must match existing record", isKey: true },
            { col: "B",  name: "dateOfMobilization",               note: "yyyy-MM-dd" },
            { col: "C",  name: "departmentId",                     note: "number" },
            { col: "D",  name: "projectId",                        note: "" },
            { col: "E",  name: "centerId",                         note: "" },
            { col: "F",  name: "projectPhase",                     note: "" },
            { col: "G",  name: "mobilizationType",                 note: "" },
            { col: "H",  name: "mobilizerName",                    note: "" },
            { col: "I",  name: "areaLocation",                     note: "" },
            { col: "J",  name: "salutation",                       note: "" },
            { col: "K",  name: "name",                             note: "" },
            { col: "L",  name: "age",                              note: "number" },
            { col: "M",  name: "gender",                           note: "" },
            { col: "N",  name: "mobileNo",                         note: "" },
            { col: "O",  name: "whatsappNumber",                   note: "" },
            { col: "P",  name: "aadharNumber",                     note: "" },
            { col: "Q",  name: "emailId",                          note: "" },
            { col: "R",  name: "highestEducationQualification",    note: "" },
            { col: "S",  name: "specifyEducation",                 note: "" },
            { col: "T",  name: "guardianName",                     note: "" },
            { col: "U",  name: "guardianContactNumber",            note: "" },
            { col: "V",  name: "workExperience",                   note: "" },
            { col: "W",  name: "willingToTakeJob",                 note: "" },
            { col: "X",  name: "willingToMigrateWithinState",      note: "" },
            { col: "Y",  name: "willingToMigrateOtherState",       note: "" },
            { col: "Z",  name: "enrolledLast6Months",              note: "" },
            { col: "AA", name: "interestedCourseName",             note: "" },
            { col: "AB", name: "hearAboutUs",                      note: "" },
            { col: "AC", name: "counselled",                       note: "" },
            { col: "AD", name: "rocVerificationStatus",            note: "" },
        ],
    },
    {
        label: "Enrollment Verification",
        endpoint: "enrollment-verification",
        keyField: "beneficiaryId",
        idKey: "beneficiaryId",
        keyExample: "EP/BEN-00001",
        excelCols: [
            { col: "A",  name: "beneficiaryId",        note: "KEY — must match existing record", isKey: true },
            { col: "B",  name: "mobilizationDate",     note: "yyyy-MM-dd" },
            { col: "C",  name: "projectId",            note: "" },
            { col: "D",  name: "projectPhase",         note: "" },
            { col: "E",  name: "centreName",           note: "" },
            { col: "F",  name: "centerId",             note: "" },
            { col: "G",  name: "mobilizationType",     note: "" },
            { col: "H",  name: "mobilizerName",        note: "" },
            { col: "I",  name: "areaLocation",         note: "" },
            { col: "J",  name: "salutation",           note: "" },
            { col: "K",  name: "name",                 note: "" },
            { col: "L",  name: "age",                  note: "number" },
            { col: "M",  name: "mobileNo",             note: "" },
            { col: "N",  name: "whatsappNumber",       note: "" },
            { col: "O",  name: "aadharNumber",         note: "" },
            { col: "P",  name: "gender",               note: "" },
            { col: "Q",  name: "email",                note: "" },
            { col: "R",  name: "highestEducation",     note: "" },
            { col: "S",  name: "educationSpecify",     note: "" },
            { col: "T",  name: "guardianName",         note: "" },
            { col: "U",  name: "guardianContact",      note: "" },
            { col: "V",  name: "workExperience",       note: "" },
            { col: "W",  name: "willingJob",           note: "" },
            { col: "X",  name: "migrateWithinState",   note: "" },
            { col: "Y",  name: "migrateOtherState",    note: "" },
            { col: "Z",  name: "enrolledLast6Months",  note: "" },
            { col: "AA", name: "interestedCourse",     note: "" },
            { col: "AB", name: "hearAboutUs",          note: "" },
            { col: "AC", name: "counselled",           note: "" },
            { col: "AD", name: "counselledBy",         note: "" },
            { col: "AE", name: "rocVerificationStatus",note: "" },
            { col: "AF", name: "rocRemarks",           note: "" },
        ],
    },
    {
        label: "Candidates",
        endpoint: "candidates",
        keyField: "beneficiaryId",
        idKey: "beneficiaryId",
        keyExample: "EP/BEN-00001",
        excelCols: [
            { col: "A",  name: "beneficiaryId",                    note: "KEY — must match existing record", isKey: true },
            { col: "B",  name: "projectId",                        note: "" },
            { col: "C",  name: "centerId",                         note: "" },
            { col: "D",  name: "epBatchId",                        note: "" },
            { col: "E",  name: "projectName",                      note: "" },
            { col: "F",  name: "projectPhase",                     note: "" },
            { col: "G",  name: "financialYear",                    note: "" },
            { col: "H",  name: "date",                             note: "yyyy-MM-dd" },
            { col: "I",  name: "sidhBeneficiaryId",                note: "" },
            { col: "J",  name: "salutation",                       note: "" },
            { col: "K",  name: "beneficiaryName",                  note: "" },
            { col: "L",  name: "dateOfBirth",                      note: "yyyy-MM-dd" },
            { col: "M",  name: "gender",                           note: "" },
            { col: "N",  name: "maritalStatus",                    note: "" },
            { col: "O",  name: "familyEconomicStatus",             note: "" },
            { col: "P",  name: "religion",                         note: "" },
            { col: "Q",  name: "casteCategory",                    note: "" },
            { col: "R",  name: "percentage12th",                   note: "number" },
            { col: "S",  name: "percentageUnderGraduation",        note: "number" },
            { col: "T",  name: "percentagePostGraduation",         note: "number" },
            { col: "U",  name: "collegeName",                      note: "" },
            { col: "V",  name: "ugDegreeName",                     note: "" },
            { col: "W",  name: "ugDegreeYear",                     note: "" },
            { col: "X",  name: "highestEducationLevel",            note: "" },
            { col: "Y",  name: "stream",                           note: "" },
            { col: "Z",  name: "year",                             note: "" },
            { col: "AA", name: "location",                         note: "" },
            { col: "AB", name: "universityName",                   note: "" },
            { col: "AC", name: "guardianType",                     note: "" },
            { col: "AD", name: "guardianName",                     note: "" },
            { col: "AE", name: "motherName",                       note: "" },
            { col: "AF", name: "guardianOccupation",               note: "" },
            { col: "AG", name: "mainEarningMember",                note: "" },
            { col: "AH", name: "totalEarningMember",               note: "number" },
            { col: "AI", name: "annualHouseholdIncome",            note: "number" },
            { col: "AJ", name: "incomeProof",                      note: "" },
            { col: "AK", name: "totalFamilyMembers",               note: "number" },
            { col: "AL", name: "identificationType",               note: "" },
            { col: "AM", name: "idNumber",                         note: "" },
            { col: "AN", name: "beneficiaryMobileNumber",          note: "" },
            { col: "AO", name: "guardianMobileNumber",             note: "" },
            { col: "AP", name: "registeredMobileNumber",           note: "" },
            { col: "AQ", name: "emailId",                          note: "" },
            { col: "AR", name: "beneficiaryAddressType",           note: "" },
            { col: "AS", name: "address",                          note: "" },
            { col: "AT", name: "district",                         note: "" },
            { col: "AU", name: "state",                            note: "" },
            { col: "AV", name: "pinCode",                          note: "" },
            { col: "AW", name: "disabilityType",                   note: "" },
            { col: "AX", name: "disabilityDegree",                 note: "" },
            { col: "AY", name: "pwdCertificate",                   note: "" },
            { col: "AZ", name: "pwdCertificateId",                 note: "" },
            { col: "BA", name: "batchName",                        note: "" },
            { col: "BB", name: "batchIdSidh",                      note: "" },
            { col: "BC", name: "jioBpContractEmployee",            note: "" },
            { col: "BD", name: "traineeType",                      note: "" },
            { col: "BE", name: "fresherRefresher",                 note: "" },
            { col: "BF", name: "phoneType",                        note: "" },
            { col: "BG", name: "vehicleNumber",                    note: "" },
            { col: "BH", name: "modeOfAttendingTraining",          note: "" },
            { col: "BI", name: "familyMembersAttendingTraining",   note: "number" },
            { col: "BJ", name: "dependentFamilyMembers",           note: "number" },
        ],
    },
    {
        label: "Training Completion",
        endpoint: "training-completion",
        keyField: "beneficiaryId",
        idKey: "beneficiaryId",
        keyExample: "EP/BEN-00001",
        excelCols: [
            { col: "A", name: "beneficiaryId",   note: "KEY — must match existing record", isKey: true },
            { col: "B", name: "beneficiaryName", note: "" },
            { col: "C", name: "trainingStatus",  note: "" },
            { col: "D", name: "dropoutReason",   note: "" },
            { col: "E", name: "batchId",         note: "" },
            { col: "F", name: "centerId",        note: "" },
            { col: "G", name: "projectId",       note: "" },
        ],
    },
    {
        label: "Pre/Post Score",
        endpoint: "pre-post-score",
        keyField: "beneficiaryId",
        idKey: "beneficiaryId",
        keyExample: "EP/BEN-00001",
        excelCols: [
            { col: "A", name: "beneficiaryId",   note: "KEY — must match existing record", isKey: true },
            { col: "B", name: "beneficiaryName", note: "" },
            { col: "C", name: "preTestScore",    note: "number" },
            { col: "D", name: "postTestScore",   note: "number" },
            { col: "E", name: "batchId",         note: "" },
            { col: "F", name: "centerId",        note: "" },
            { col: "G", name: "projectId",       note: "" },
        ],
    },
    {
        label: "Candidate Retention",
        endpoint: "candidate-retention",
        keyField: "beneficiaryId",
        idKey: "beneficiaryId",
        keyExample: "EP/BEN-00001",
        excelCols: [
            { col: "A",  name: "beneficiaryId",               note: "KEY — must match existing record", isKey: true },
            { col: "B",  name: "beneficiaryName",             note: "" },
            { col: "C",  name: "currentEmploymentStatus1",    note: "Round 1" },
            { col: "D",  name: "sameOrDifferentJob1",         note: "" },
            { col: "E",  name: "differentEmployerName1",      note: "" },
            { col: "F",  name: "newDateOfJoining1",           note: "yyyy-MM-dd" },
            { col: "G",  name: "newBeneficiaryDesignation1",  note: "" },
            { col: "H",  name: "newIncomePerMonth1",          note: "number" },
            { col: "I",  name: "unemployedReason1",           note: "" },
            { col: "J",  name: "retentionProofCollected1",    note: "true/false/yes/no/1/0" },
            { col: "K",  name: "currentEmploymentStatus2",    note: "Round 2" },
            { col: "L",  name: "sameOrDifferentJob2",         note: "" },
            { col: "M",  name: "differentEmployerName2",      note: "" },
            { col: "N",  name: "newDateOfJoining2",           note: "yyyy-MM-dd" },
            { col: "O",  name: "newBeneficiaryDesignation2",  note: "" },
            { col: "P",  name: "newIncomePerMonth2",          note: "number" },
            { col: "Q",  name: "unemployedReason2",           note: "" },
            { col: "R",  name: "retentionProofCollected2",    note: "true/false/yes/no/1/0" },
            { col: "S",  name: "currentEmploymentStatus3",    note: "Round 3" },
            { col: "T",  name: "sameOrDifferentJob3",         note: "" },
            { col: "U",  name: "differentEmployerName3",      note: "" },
            { col: "V",  name: "newDateOfJoining3",           note: "yyyy-MM-dd" },
            { col: "W",  name: "newBeneficiaryDesignation3",  note: "" },
            { col: "X",  name: "newIncomePerMonth3",          note: "number" },
            { col: "Y",  name: "unemployedReason3",           note: "" },
            { col: "Z",  name: "retentionProofCollected3",    note: "true/false/yes/no/1/0" },
            { col: "AA", name: "currentEmploymentStatus4",    note: "Round 4" },
            { col: "AB", name: "sameOrDifferentJob4",         note: "" },
            { col: "AC", name: "differentEmployerName4",      note: "" },
            { col: "AD", name: "newDateOfJoining4",           note: "yyyy-MM-dd" },
            { col: "AE", name: "newBeneficiaryDesignation4",  note: "" },
            { col: "AF", name: "newIncomePerMonth4",          note: "number" },
            { col: "AG", name: "unemployedReason4",           note: "" },
            { col: "AH", name: "retentionProofCollected4",    note: "true/false/yes/no/1/0" },
            { col: "AI", name: "currentEmploymentStatus5",    note: "Round 5" },
            { col: "AJ", name: "sameOrDifferentJob5",         note: "" },
            { col: "AK", name: "differentEmployerName5",      note: "" },
            { col: "AL", name: "newDateOfJoining5",           note: "yyyy-MM-dd" },
            { col: "AM", name: "newBeneficiaryDesignation5",  note: "" },
            { col: "AN", name: "newIncomePerMonth5",          note: "number" },
            { col: "AO", name: "unemployedReason5",           note: "" },
            { col: "AP", name: "retentionProofCollected5",    note: "true/false/yes/no/1/0" },
            { col: "AQ", name: "currentEmploymentStatus6",    note: "Round 6" },
            { col: "AR", name: "sameOrDifferentJob6",         note: "" },
            { col: "AS", name: "differentEmployerName6",      note: "" },
            { col: "AT", name: "newDateOfJoining6",           note: "yyyy-MM-dd" },
            { col: "AU", name: "newBeneficiaryDesignation6",  note: "" },
            { col: "AV", name: "newIncomePerMonth6",          note: "number" },
            { col: "AW", name: "unemployedReason6",           note: "" },
            { col: "AX", name: "retentionProofCollected6",    note: "true/false/yes/no/1/0" },
            { col: "AY", name: "batchId",                     note: "" },
            { col: "AZ", name: "centerId",                    note: "" },
            { col: "BA", name: "projectId",                   note: "" },
        ],
    },
    {
        label: "Health Camp",
        endpoint: "health-camp",
        keyField: "beneficiaryId",
        idKey: "beneficiaryId",
        keyExample: "EP/BEN-00001",
        excelCols: [
            { col: "A", name: "projectId",               note: "" },
            { col: "B", name: "projectPhase",            note: "" },
            { col: "C", name: "batchId",                 note: "" },
            { col: "D", name: "centerId",                note: "" },
            { col: "E", name: "beneficiaryId",           note: "KEY — must match existing record", isKey: true },
            { col: "F", name: "beneficiaryName",         note: "" },
            { col: "G", name: "regularHealthCheckup",    note: "Yes / No" },
            { col: "H", name: "interventionType",        note: "" },
            { col: "I", name: "vitalsConsultation",      note: "" },
            { col: "J", name: "reConsultations",         note: "" },
            { col: "K", name: "diseaseCategory",         note: "" },
            { col: "L", name: "causesForConsultation",   note: "" },
            { col: "M", name: "eyeCheckup",              note: "Yes / No" },
            { col: "N", name: "visionRight",             note: "" },
            { col: "O", name: "visionLeft",              note: "" },
            { col: "P", name: "visionAdd",               note: "" },
            { col: "Q", name: "visionRemarks",           note: "" },
            { col: "R", name: "opticalSpecsNeeded",      note: "Yes / No" },
            { col: "S", name: "opticalSpecsAvailable",   note: "Yes / No" },
            { col: "T", name: "readingSpecsProvided",    note: "Yes / No" },
            { col: "U", name: "bifocalSpecsProvided",    note: "Yes / No" },
            { col: "V", name: "distanceSpecsProvided",   note: "Yes / No" },
            { col: "W", name: "colourBlindness",         note: "" },
        ],
    },
    {
        label: "Internal Assessment",
        endpoint: "internal-assessment",
        keyField: "beneficiaryId",
        idKey: "beneficiaryId",
        keyExample: "EP/BEN-00001",
        excelCols: [
            { col: "A", name: "beneficiaryId",                note: "KEY — must match existing record", isKey: true },
            { col: "B", name: "beneficiaryName",              note: "" },
            { col: "C", name: "assessment",                   note: "Yes / No" },
            { col: "D", name: "attendancePercentage",         note: "number" },
            { col: "E", name: "assessmentConducted",          note: "Yes / No" },
            { col: "F", name: "assessmentThroughMode",        note: "" },
            { col: "G", name: "assessmentAgencyId",           note: "" },
            { col: "H", name: "assessmentAgencyName",         note: "" },
            { col: "I", name: "assessorId",                   note: "" },
            { col: "J", name: "assessmentDate",               note: "dd/MM/yyyy or yyyy-MM-dd" },
            { col: "K", name: "beneficiaryAssessmentStatus",  note: "" },
            { col: "L", name: "assessmentPercentage",         note: "number" },
            { col: "M", name: "batchId",                      note: "" },
            { col: "N", name: "centerId",                     note: "" },
            { col: "O", name: "projectId",                    note: "" },
        ],
    },
    {
        label: "External Assessment",
        endpoint: "external-assessment",
        keyField: "beneficiaryId",
        idKey: "beneficiaryId",
        keyExample: "EP/BEN-00001",
        excelCols: [
            { col: "A", name: "beneficiaryId",                note: "KEY — must match existing record", isKey: true },
            { col: "B", name: "beneficiaryName",              note: "" },
            { col: "C", name: "assessment",                   note: "Yes / No" },
            { col: "D", name: "attendancePercentage",         note: "number" },
            { col: "E", name: "assessmentConducted",          note: "Yes / No" },
            { col: "F", name: "assessmentThroughMode",        note: "" },
            { col: "G", name: "assessmentAgencyId",           note: "" },
            { col: "H", name: "assessmentAgencyName",         note: "" },
            { col: "I", name: "assessorId",                   note: "" },
            { col: "J", name: "assessorName",                 note: "" },
            { col: "K", name: "assessmentDate",               note: "dd/MM/yyyy or yyyy-MM-dd" },
            { col: "L", name: "beneficiaryAssessmentStatus",  note: "" },
            { col: "M", name: "assessmentPercentage",         note: "number" },
            { col: "N", name: "batchId",                      note: "" },
            { col: "O", name: "centerId",                     note: "" },
            { col: "P", name: "projectId",                    note: "" },
        ],
    },
    {
        label: "Certificate",
        endpoint: "certificate",
        keyField: "beneficiaryId",
        idKey: "beneficiaryId",
        keyExample: "EP/BEN-00001",
        excelCols: [
            { col: "A", name: "beneficiaryId",    note: "KEY — must match existing record", isKey: true },
            { col: "B", name: "beneficiaryName",  note: "" },
            { col: "C", name: "certifyingAgency", note: "" },
            { col: "D", name: "certified",        note: "Yes / No" },
            { col: "E", name: "certificationDate",note: "dd/MM/yyyy or yyyy-MM-dd" },
            { col: "F", name: "certificateNo",    note: "" },
            { col: "G", name: "batchId",          note: "" },
            { col: "H", name: "centerId",         note: "" },
            { col: "I", name: "projectId",        note: "" },
        ],
    },
    {
        label: "Placement",
        endpoint: "placement",
        keyField: "beneficiaryId",
        idKey: "beneficiaryId",
        keyExample: "EP/BEN-00001",
        excelCols: [
            { col: "A", name: "beneficiaryId",            note: "KEY — must match existing record", isKey: true },
            { col: "B", name: "beneficiaryName",          note: "" },
            { col: "C", name: "placementStatus",          note: "Yes / No" },
            { col: "D", name: "joiningStatus",            note: "Yes / No" },
            { col: "E", name: "notJoinedReason",          note: "" },
            { col: "F", name: "employmentType",           note: "" },
            { col: "G", name: "dateOfPlacement",          note: "dd/MM/yyyy or yyyy-MM-dd" },
            { col: "H", name: "employerNameSelfEmployed", note: "" },
            { col: "I", name: "pointPersonName",          note: "" },
            { col: "J", name: "pointPersonContactNo",     note: "" },
            { col: "K", name: "pointPersonEmailId",       note: "" },
            { col: "L", name: "pointPersonDesignation",   note: "" },
            { col: "M", name: "beneficiaryDesignation",   note: "" },
            { col: "N", name: "incomePerMonth",           note: "number" },
            { col: "O", name: "offerLetterCollected",     note: "Yes / No" },
            { col: "P", name: "employerAddress",          note: "" },
            { col: "Q", name: "districtOfPlacement",      note: "" },
            { col: "R", name: "stateOfPlacement",         note: "" },
            { col: "S", name: "batchId",                  note: "" },
            { col: "T", name: "centerId",                 note: "" },
            { col: "U", name: "projectId",                note: "" },
        ],
    },
    {
        label: "Other Activities",
        endpoint: "other-activities",
        keyField: "beneficiaryId",
        idKey: "beneficiaryId",
        keyExample: "EP/BEN-00001",
        excelCols: [
            { col: "A", name: "beneficiaryId",                    note: "KEY — must match existing record", isKey: true },
            { col: "B", name: "beneficiaryName",                  note: "" },
            { col: "C", name: "kitDistributionDate",              note: "dd/MM/yyyy or yyyy-MM-dd" },
            { col: "D", name: "kitDistribution",                  note: "Yes / No" },
            { col: "E", name: "guestLectureAttendedDate",         note: "dd/MM/yyyy or yyyy-MM-dd" },
            { col: "F", name: "guestLectureAttended",             note: "Yes / No" },
            { col: "G", name: "midTermFeedbackFormDate",          note: "dd/MM/yyyy or yyyy-MM-dd" },
            { col: "H", name: "midTermFeedbackForm",              note: "Yes / No" },
            { col: "I", name: "industryVisitMarketVisitDate",     note: "dd/MM/yyyy or yyyy-MM-dd" },
            { col: "J", name: "industryVisitMarketVisitAttended", note: "Yes / No" },
            { col: "K", name: "rozgarMelaNsdcEventsDate",         note: "dd/MM/yyyy or yyyy-MM-dd" },
            { col: "L", name: "rozgarMelaNsdcEvents",             note: "" },
            { col: "M", name: "alumniMeetDate",                   note: "dd/MM/yyyy or yyyy-MM-dd" },
            { col: "N", name: "alumniMeetAttended",               note: "Yes / No" },
            { col: "O", name: "ptmDate",                          note: "dd/MM/yyyy or yyyy-MM-dd" },
            { col: "P", name: "ptm",                              note: "Yes / No" },
            { col: "Q", name: "ojtDate",                          note: "dd/MM/yyyy or yyyy-MM-dd" },
            { col: "R", name: "ojt",                              note: "Yes / No" },
            { col: "S", name: "centerId",                         note: "" },
            { col: "T", name: "batchId",                          note: "" },
            { col: "U", name: "projectId",                        note: "" },
        ],
    },
    {
        label: "Attendance",
        endpoint: "attendance",
        keyField: "beneficiaryId + attendanceDate",
        idKey: "beneficiaryId",
        keyExample: "EP/BEN-00001",
        headerBased: true,
        excelCols: [
            { col: "A", name: "Beneficiary ID",        note: "KEY part 1 — must exist in database", isKey: true },
            { col: "B", name: "Mark For Date",         note: "KEY part 2 — dd/MM/yyyy or yyyy-MM-dd" },
            { col: "C", name: "Status",                note: "e.g. Present / Absent" },
            { col: "D", name: "Update Date",           note: "dd/MM/yyyy or yyyy-MM-dd" },
            { col: "E", name: "EP Portal Centre ID",   note: "" },
            { col: "F", name: "EP Portal Batch ID",    note: "" },
            { col: "G", name: "Project ID",            note: "" },
        ],
    },
    {
        label: "JioBP Healthcamp Feedback",
        endpoint: "jiobp-healthcamp-feedback",
        keyField: "beneficiaryId",
        idKey: "beneficiaryId",
        keyExample: "EP/BEN-00001",
        excelCols: [
            { col: "A", name: "beneficiaryId",              note: "KEY — must match existing record", isKey: true },
            { col: "B", name: "callingStatus",              note: "" },
            { col: "C", name: "visitedHealthCamp",          note: "" },
            { col: "D", name: "onlineConsultation",         note: "" },
            { col: "E", name: "onlineConsultationDuration", note: "" },
            { col: "F", name: "doctorUnderstoodProblem",    note: "" },
            { col: "G", name: "medicinesPrescribedOrTest",  note: "" },
            { col: "H", name: "tookPrescribedMedicines",    note: "" },
            { col: "I", name: "ifNoSpecify",                note: "" },
            { col: "J", name: "problemStatus",              note: "" },
            { col: "K", name: "onlineConsultationHelpful",  note: "" },
            { col: "L", name: "wouldConsultAgain",          note: "" },
            { col: "M", name: "satisfactionRating",         note: "1–5" },
            { col: "N", name: "otherRemarks",               note: "" },
            { col: "O", name: "finalCallingStatus",         note: "" },
            { col: "P", name: "remarks",                    note: "" },
            { col: "Q", name: "date",                       note: "" },
            { col: "R", name: "agent",                      note: "" },
            { col: "S", name: "projectId",                  note: "" },
            { col: "T", name: "projectPhase",               note: "" },
            { col: "U", name: "batchId",                    note: "" },
            { col: "V", name: "centerId",                   note: "" },
        ],
    },
    {
        label: "JioBP Training Feedback",
        endpoint: "jiobp-training-feedback-calls",
        keyField: "beneficiaryId",
        idKey: "beneficiaryId",
        keyExample: "EP/BEN-00001",
        excelCols: [
            { col: "A", name: "beneficiaryId",          note: "KEY — must match existing record", isKey: true },
            { col: "B", name: "roadSafetyAwareness",    note: "" },
            { col: "C", name: "vehicularSafetyCheckup", note: "" },
            { col: "D", name: "challansReduced",        note: "" },
            { col: "E", name: "incomeSavingHelp",       note: "" },
            { col: "F", name: "incomeSavingAmount",     note: "" },
            { col: "G", name: "govtSchemeEnrolled",     note: "" },
            { col: "H", name: "trainingRating",         note: "" },
            { col: "I", name: "attendFutureProgramme",  note: "" },
            { col: "J", name: "futureTopics",           note: "" },
            { col: "K", name: "anyOtherRemarks",        note: "" },
            { col: "L", name: "finalStatus",            note: "" },
            { col: "M", name: "remarks",                note: "" },
            { col: "N", name: "date",                   note: "" },
            { col: "O", name: "agentName",              note: "" },
        ],
    },
    {
        label: "Placed Impact Assessment",
        endpoint: "placed-impact-assessment",
        keyField: "beneficiaryId",
        idKey: "beneficiaryId",
        keyExample: "EP/BEN-00001",
        excelCols: [
            { col: "A",  name: "beneficiaryId",                note: "KEY — must match existing record", isKey: true },
            { col: "B",  name: "location",                     note: "" },
            { col: "C",  name: "batchName",                    note: "" },
            { col: "D",  name: "batchId",                      note: "" },
            { col: "E",  name: "uniqueTraineeId",              note: "" },
            { col: "F",  name: "name",                         note: "" },
            { col: "G",  name: "mobileNumber",                 note: "" },
            { col: "H",  name: "salutation",                   note: "" },
            { col: "I",  name: "nameOfTrainee",                note: "" },
            { col: "J",  name: "dateOfBirth",                  note: "" },
            { col: "K",  name: "gender",                       note: "" },
            { col: "L",  name: "traineeMobileNumber",          note: "" },
            { col: "M",  name: "guardianContactNumber",        note: "" },
            { col: "N",  name: "emailId",                      note: "" },
            { col: "O",  name: "traineeAddress",               note: "" },
            { col: "P",  name: "district",                     note: "" },
            { col: "Q",  name: "state",                        note: "" },
            { col: "R",  name: "batchEndDate",                 note: "" },
            { col: "S",  name: "placementStatus",              note: "" },
            { col: "T",  name: "dateOfPlacement",              note: "" },
            { col: "U",  name: "employerName",                 note: "" },
            { col: "V",  name: "nameOfPointPerson",            note: "" },
            { col: "W",  name: "contactNoOfPointPerson",       note: "" },
            { col: "X",  name: "emailIdOfPointPerson",         note: "" },
            { col: "Y",  name: "designationOfPointPerson",     note: "" },
            { col: "Z",  name: "designationOfTrainee",         note: "" },
            { col: "AA", name: "incomePerMonth",               note: "" },
            { col: "AB", name: "offerLetterCollected",         note: "" },
            { col: "AC", name: "employerAddress",              note: "" },
            { col: "AD", name: "districtOfPlacement",          note: "" },
            { col: "AE", name: "stateOfPlacement",             note: "" },
            { col: "AF", name: "callStatus",                   note: "" },
            { col: "AG", name: "respondent",                   note: "" },
            { col: "AH", name: "alternateMobileNumber",        note: "" },
            { col: "AI", name: "callRescheduleDate",           note: "" },
            { col: "AJ", name: "currentlyEmployed",            note: "" },
            { col: "AK", name: "specifyOthers",                note: "" },
            { col: "AL", name: "lastWorkDate",                 note: "" },
            { col: "AM", name: "reasonForLeavingJob",          note: "" },
            { col: "AN", name: "activelyLookingForJob",        note: "" },
            { col: "AO", name: "companyOrganizationName",      note: "" },
            { col: "AP", name: "jobRoleDesignation",           note: "" },
            { col: "AQ", name: "jobLocationDistrict",          note: "" },
            { col: "AR", name: "jobLocationCityState",         note: "" },
            { col: "AS", name: "typeOfEmployment",             note: "" },
            { col: "AT", name: "currentSalary",                note: "" },
            { col: "AU", name: "promotionsOrRoleChanges",      note: "" },
            { col: "AV", name: "specifyPromotion",             note: "" },
            { col: "AW", name: "specifyRoleChange",            note: "" },
            { col: "AX", name: "specifyIncrement",             note: "" },
            { col: "AY", name: "trainingHelpedGetJob",         note: "" },
            { col: "AZ", name: "trainingNotUseful",            note: "" },
            { col: "BA", name: "confidenceInJobTasks",         note: "" },
            { col: "BB", name: "satisfiedWithJob",             note: "" },
            { col: "BC", name: "reasonForDissatisfaction",     note: "" },
            { col: "BD", name: "recommendTrainingProgram",     note: "" },
            { col: "BE", name: "suggestionsForFutureTraining", note: "" },
            { col: "BF", name: "newOfferLetterCollected",      note: "" },
            { col: "BG", name: "newSalarySlipCollected",       note: "" },
            { col: "BH", name: "remarks",                      note: "" },
            { col: "BI", name: "rocMemberName",                note: "" },
            { col: "BJ", name: "date",                         note: "" },
        ],
    },
    {
        label: "Enterprise Support",
        endpoint: "enterprise-support",
        keyField: "beneficiaryId",
        idKey: "beneficiaryId",
        keyExample: "EP/BEN-00001",
        excelCols: [
            { col: "A", name: "beneficiaryId",           note: "KEY — must match existing record", isKey: true },
            { col: "B", name: "sector",                  note: "" },
            { col: "C", name: "setupType",               note: "" },
            { col: "D", name: "udyamRegistration",       note: "" },
            { col: "E", name: "udyamRegistrationNumber", note: "" },
            { col: "F", name: "logbooksCreated",         note: "" },
            { col: "G", name: "digitalPaymentsSetup",    note: "" },
            { col: "H", name: "brandingProvided",        note: "" },
            { col: "I", name: "gstRegistered",           note: "" },
            { col: "J", name: "gstNumber",               note: "" },
            { col: "K", name: "platform1Listing",        note: "" },
            { col: "L", name: "platform1Link",           note: "" },
            { col: "M", name: "platform2Listing",        note: "" },
            { col: "N", name: "platform2Link",           note: "" },
            { col: "O", name: "platform3Listing",        note: "" },
            { col: "P", name: "platform3Link",           note: "" },
            { col: "Q", name: "platform4Listing",        note: "" },
            { col: "R", name: "platform4Link",           note: "" },
            { col: "S", name: "platform5Listing",        note: "" },
            { col: "T", name: "platform5Link",           note: "" },
            { col: "U", name: "trade",                   note: "" },
            { col: "V", name: "businessName",            note: "" },
        ],
    },
];

export default function BulkUpdatePage() {
    const token = localStorage.getItem("token");
    const authHeaders = { Authorization: `Bearer ${token}` };

    const [moduleIdx, setModuleIdx] = useState(0);
    const [file, setFile] = useState(null);
    const [dragging, setDragging] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState("");
    const [schemaOpen, setSchemaOpen] = useState(false);

    const fileInputRef = useRef(null);
    const selectedModule = MODULES[moduleIdx];

    // ── file selection ────────────────────────────────────────────────────────

    const acceptFile = (f) => {
        if (!f) return;
        const name = f.name.toLowerCase();
        if (!name.endsWith(".xlsx") && !name.endsWith(".xls")) {
            setError("Only .xlsx / .xls files are accepted");
            return;
        }
        setFile(f);
        setResult(null);
        setError("");
    };

    const onDrop = (e) => {
        e.preventDefault();
        setDragging(false);
        acceptFile(e.dataTransfer.files[0]);
    };

    // ── upload ────────────────────────────────────────────────────────────────

    const handleUpload = async () => {
        if (!file) { setError("Please select an Excel file first"); return; }

        setUploading(true);
        setResult(null);
        setError("");

        const formData = new FormData();
        formData.append("file", file);

        try {
            const res = await fetch(
                `${BASE_URL}/api/bulk-update/${selectedModule.endpoint}/upload`,
                { method: "POST", headers: authHeaders, body: formData }
            );

            const text = await res.text();
            let data;
            try { data = text ? JSON.parse(text) : {}; } catch { data = { raw: text }; }

            if (!res.ok) {
                setError(data?.message || data?.raw || `Request failed (${res.status})`);
            } else {
                setResult(data);
                setFile(null);
                if (fileInputRef.current) fileInputRef.current.value = "";
            }
        } catch (err) {
            setError("Network error — " + err.message);
        } finally {
            setUploading(false);
        }
    };

    // ── render ────────────────────────────────────────────────────────────────

    const skipped = result?.skippedDetails ?? [];

    return (
        <div className="bu-page">

            {/* Header */}
            <div className="bu-header">
                <div>
                    <h1 className="bu-title">Bulk Update</h1>
                    <p className="bu-subtitle">Upload an Excel file to update existing records by their unique ID</p>
                </div>
                <span className="bu-badge">Update Only · No Insert</span>
            </div>

            {/* 1. Module selector */}
            <div className="bu-card">
                <div className="bu-card-title">1 · Select Module</div>
                <div className="bu-modules">
                    {MODULES.map((m, i) => (
                        <button
                            key={m.endpoint}
                            className={`bu-mod-btn${moduleIdx === i ? " active" : ""}`}
                            onClick={() => { setModuleIdx(i); setFile(null); setResult(null); setError(""); }}
                        >
                            {m.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* 2. Excel format guide */}
            <div className="bu-card">
                <button
                    className="bu-schema-toggle"
                    onClick={() => setSchemaOpen(v => !v)}
                >
                    <span>2 · Excel Format — <strong>{selectedModule.label}</strong></span>
                    <span className="bu-chevron">{schemaOpen ? "▲" : "▼"}</span>
                </button>

                {schemaOpen && (
                    <div className="bu-schema-body">
                        <p className="bu-schema-note">
                            Row 1 = header (ignored). Data starts from Row 2.
                            Column <strong>{selectedModule.excelCols.find(c => c.isKey)?.col ?? "A"} ({selectedModule.keyField})</strong> is the match key — must exist in the database.
                        </p>
                        <div className="bu-schema-table-wrap">
                            <table className="bu-schema-table">
                                <thead>
                                    <tr>
                                        <th>Col</th>
                                        <th>Field Name</th>
                                        <th>Notes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedModule.excelCols.map((c) => (
                                        <tr key={c.col} className={c.isKey ? "bu-key-row" : ""}>
                                            <td className="bu-col-letter">{c.col}</td>
                                            <td className="bu-col-name">{c.name}{c.isKey && <span className="bu-key-tag">KEY</span>}</td>
                                            <td className="bu-col-note">{c.note}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>

            {/* 3. Upload */}
            <div className="bu-card">
                <div className="bu-card-title">3 · Upload Excel File</div>

                {/* Drop zone */}
                <div
                    className={`bu-dropzone${dragging ? " drag-over" : ""}${file ? " has-file" : ""}`}
                    onClick={() => fileInputRef.current?.click()}
                    onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
                    onDragLeave={() => setDragging(false)}
                    onDrop={onDrop}
                >
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept=".xlsx,.xls"
                        style={{ display: "none" }}
                        onChange={(e) => acceptFile(e.target.files[0])}
                    />
                    {file ? (
                        <div className="bu-file-selected">
                            <span className="bu-file-icon">📄</span>
                            <span className="bu-file-name">{file.name}</span>
                            <span className="bu-file-size">({(file.size / 1024).toFixed(1)} KB)</span>
                            <button
                                className="bu-file-clear"
                                onClick={(e) => { e.stopPropagation(); setFile(null); setResult(null); setError(""); }}
                            >✕</button>
                        </div>
                    ) : (
                        <div className="bu-drop-prompt">
                            <div className="bu-drop-icon">⬆</div>
                            <div className="bu-drop-text">
                                Drag & drop your Excel file here, or <span className="bu-link">click to browse</span>
                            </div>
                            <div className="bu-drop-hint">.xlsx / .xls only</div>
                        </div>
                    )}
                </div>

                {/* Upload button */}
                <div style={{ marginTop: 14, display: "flex", gap: 10, alignItems: "center" }}>
                    <button
                        className="bu-btn bu-btn-primary"
                        onClick={handleUpload}
                        disabled={uploading || !file}
                    >
                        {uploading ? (
                            <><span className="bu-spinner" />Uploading…</>
                        ) : (
                            `Update ${selectedModule.label}`
                        )}
                    </button>
                    {file && !uploading && (
                        <button
                            className="bu-btn"
                            onClick={() => { setFile(null); setResult(null); setError(""); }}
                        >
                            Clear
                        </button>
                    )}
                </div>
            </div>

            {/* Error */}
            {error && <div className="bu-flash bu-flash-err">{error}</div>}

            {/* Result */}
            {result && (
                <div className="bu-card">
                    <div className="bu-card-title">
                        Result — {selectedModule.label}
                        <span className="bu-result-tag">Upload complete</span>
                    </div>

                    {/* Summary stats */}
                    <div className="bu-stats">
                        <div className="bu-stat">
                            <div className="bu-stat-num">{result.totalRows ?? 0}</div>
                            <div className="bu-stat-label">Total Rows</div>
                        </div>
                        <div className="bu-stat bu-stat-ok">
                            <div className="bu-stat-num">{result.updated ?? 0}</div>
                            <div className="bu-stat-label">Updated</div>
                        </div>
                        <div className={`bu-stat${(result.skipped ?? 0) > 0 ? " bu-stat-warn" : ""}`}>
                            <div className="bu-stat-num">{result.skipped ?? 0}</div>
                            <div className="bu-stat-label">Skipped</div>
                        </div>
                    </div>

                    {/* Skipped details table */}
                    {skipped.length > 0 && (
                        <div className="bu-skipped">
                            <div className="bu-skipped-title">
                                Skipped Details ({skipped.length} row{skipped.length !== 1 ? "s" : ""})
                            </div>
                            <div className="bu-table-wrap">
                                <table className="bu-table">
                                    <thead>
                                        <tr>
                                            <th>Row #</th>
                                            <th>{selectedModule.keyField}</th>
                                            <th>Reason</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {skipped.map((d, i) => (
                                            <tr key={i}>
                                                <td className="bu-td-row">{d.row}</td>
                                                <td className="bu-td-id">{d[selectedModule.idKey] || "—"}</td>
                                                <td className="bu-td-reason">{d.reason}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {skipped.length === 0 && (
                        <div className="bu-all-ok">
                            ✓ All rows updated successfully — no skips
                        </div>
                    )}
                </div>
            )}

            <style>{`
.bu-page {
    padding: 24px 28px;
    background: #f7f7fb;
    min-height: 100vh;
    font-family: Inter, system-ui, sans-serif;
    color: #111827;
}

/* Header */
.bu-header {
    display: flex; justify-content: space-between; align-items: flex-start;
    margin-bottom: 20px;
}
.bu-title  { margin: 0 0 4px; font-size: 24px; font-weight: 900; color: #0f172a; }
.bu-subtitle { font-size: 13px; color: #6b7280; margin: 0; }
.bu-badge {
    background: #eff6ff; color: #1d4ed8;
    font-size: 11px; font-weight: 800; padding: 5px 12px;
    border-radius: 999px; white-space: nowrap;
}

/* Card */
.bu-card {
    background: #fff; border: 1px solid #e5e7eb;
    border-radius: 14px; padding: 18px 20px; margin-bottom: 14px;
}
.bu-card-title {
    font-size: 13px; font-weight: 900; color: #111827;
    margin-bottom: 14px; display: flex; align-items: center; gap: 10px;
}
.bu-result-tag {
    background: #dcfce7; color: #166534; font-size: 11px;
    font-weight: 700; padding: 3px 10px; border-radius: 999px;
}

/* Module selector */
.bu-modules { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }
.bu-mod-btn {
    border: 1.5px solid #e5e7eb; background: #fff; padding: 8px 16px;
    border-radius: 10px; font-size: 13px; font-weight: 700; cursor: pointer;
    color: #374151; transition: all 0.15s;
}
.bu-mod-btn:hover { border-color: #2563eb; color: #2563eb; }
.bu-mod-btn.active { background: #2563eb; color: #fff; border-color: #2563eb; }
.bu-mod-soon {
    font-size: 12px; color: #9ca3af; font-weight: 600;
    padding: 6px 10px; border: 1px dashed #d1d5db; border-radius: 8px;
}

/* Schema toggle */
.bu-schema-toggle {
    width: 100%; background: none; border: none; cursor: pointer;
    display: flex; justify-content: space-between; align-items: center;
    font-size: 13px; font-weight: 700; color: #111827; padding: 0;
}
.bu-schema-toggle:hover { color: #2563eb; }
.bu-chevron { font-size: 11px; color: #6b7280; }

.bu-schema-body { margin-top: 14px; }
.bu-schema-note {
    font-size: 12px; color: #6b7280; margin: 0 0 12px;
    padding: 10px 14px; background: #f0f9ff; border-radius: 10px;
    border: 1px solid #bae6fd; line-height: 1.5;
}
.bu-schema-table-wrap { overflow-x: auto; }
.bu-schema-table {
    width: 100%; border-collapse: collapse; font-size: 12px;
}
.bu-schema-table th {
    background: #f9fafb; text-align: left; padding: 7px 12px;
    font-weight: 800; color: #374151; border-bottom: 1px solid #e5e7eb;
}
.bu-schema-table td {
    padding: 6px 12px; border-bottom: 1px solid #f3f4f6; color: #374151;
}
.bu-schema-table tr:last-child td { border-bottom: none; }
.bu-key-row td { background: #fefce8; }
.bu-col-letter { font-family: monospace; font-weight: 900; color: #1d4ed8; width: 40px; }
.bu-col-name   { font-family: monospace; font-weight: 700; }
.bu-col-note   { color: #6b7280; }
.bu-key-tag {
    background: #fef08a; color: #854d0e; font-size: 10px;
    font-weight: 900; padding: 1px 7px; border-radius: 5px; margin-left: 8px;
}

/* Drop zone */
.bu-dropzone {
    border: 2px dashed #d1d5db; border-radius: 14px;
    padding: 36px 24px; text-align: center; cursor: pointer;
    transition: all 0.2s; background: #fafafa;
}
.bu-dropzone:hover, .bu-dropzone.drag-over {
    border-color: #2563eb; background: #eff6ff;
}
.bu-dropzone.has-file {
    border-color: #16a34a; background: #f0fdf4; border-style: solid;
}
.bu-drop-icon { font-size: 32px; margin-bottom: 10px; color: #9ca3af; }
.bu-drop-text { font-size: 14px; font-weight: 600; color: #374151; margin-bottom: 6px; }
.bu-link { color: #2563eb; text-decoration: underline; cursor: pointer; }
.bu-drop-hint { font-size: 12px; color: #9ca3af; font-weight: 500; }

.bu-file-selected {
    display: flex; align-items: center; gap: 10px; justify-content: center;
    flex-wrap: wrap;
}
.bu-file-icon { font-size: 22px; }
.bu-file-name { font-size: 14px; font-weight: 800; color: #166534; font-family: monospace; }
.bu-file-size { font-size: 12px; color: #6b7280; font-weight: 600; }
.bu-file-clear {
    background: none; border: 1px solid #d1d5db; border-radius: 6px;
    cursor: pointer; color: #6b7280; padding: 2px 8px; font-size: 13px;
    font-weight: 700; line-height: 1.5;
}
.bu-file-clear:hover { border-color: #dc2626; color: #dc2626; }

/* Buttons */
.bu-btn {
    border: 1.5px solid #e5e7eb; background: #fff; padding: 10px 20px;
    border-radius: 12px; font-weight: 800; cursor: pointer; font-size: 13px;
    display: flex; align-items: center; gap: 8px; transition: all 0.15s;
}
.bu-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.bu-btn:hover:not(:disabled) { border-color: #9ca3af; }
.bu-btn-primary {
    background: #2563eb; color: #fff; border-color: #2563eb;
}
.bu-btn-primary:hover:not(:disabled) { background: #1d4ed8; border-color: #1d4ed8; }

.bu-spinner {
    width: 14px; height: 14px; border: 2px solid rgba(255,255,255,0.4);
    border-top-color: #fff; border-radius: 50%;
    animation: bu-spin 0.7s linear infinite; display: inline-block;
}
@keyframes bu-spin { to { transform: rotate(360deg); } }

/* Flash */
.bu-flash {
    padding: 12px 16px; border-radius: 10px; margin-bottom: 14px;
    font-weight: 700; font-size: 13px;
}
.bu-flash-err { background: #fef2f2; color: #991b1b; border: 1px solid #fecaca; }

/* Stats */
.bu-stats { display: flex; gap: 12px; margin-bottom: 16px; }
.bu-stat {
    flex: 1; border: 1px solid #e5e7eb; border-radius: 12px;
    padding: 16px; text-align: center;
}
.bu-stat-ok   { border-color: #a7f3d0; background: #ecfdf5; }
.bu-stat-warn { border-color: #fde68a; background: #fffbeb; }
.bu-stat-num  { font-size: 30px; font-weight: 900; color: #111827; }
.bu-stat-ok   .bu-stat-num  { color: #065f46; }
.bu-stat-warn .bu-stat-num  { color: #92400e; }
.bu-stat-label { font-size: 12px; font-weight: 700; color: #6b7280; margin-top: 4px; }

/* Skipped table */
.bu-skipped {
    border: 1px solid #fde68a; background: #fffbeb;
    border-radius: 12px; padding: 14px;
}
.bu-skipped-title {
    font-size: 12px; font-weight: 900; color: #92400e; margin-bottom: 12px;
}
.bu-table-wrap { overflow-x: auto; }
.bu-table {
    width: 100%; border-collapse: collapse; font-size: 12px;
}
.bu-table th {
    background: #fef3c7; text-align: left; padding: 7px 12px;
    font-weight: 800; color: #78350f; border-bottom: 1px solid #fde68a;
}
.bu-table td { padding: 7px 12px; border-bottom: 1px solid #fef9c3; color: #374151; }
.bu-table tr:last-child td { border-bottom: none; }
.bu-table tr:hover td { background: #fef9c3; }
.bu-td-row    { font-weight: 900; color: #92400e; width: 70px; }
.bu-td-id     { font-family: monospace; font-weight: 700; }
.bu-td-reason { color: #6b7280; }

/* All OK */
.bu-all-ok {
    background: #dcfce7; color: #166534; border: 1px solid #a7f3d0;
    border-radius: 10px; padding: 12px 16px; font-weight: 800; font-size: 13px;
}
            `}</style>
        </div>
    );
}
